import { Icon, Text } from '@/ui'
import { mtc, TypographyStyles } from '@/styles'
import { formatThreadTime } from '../../lib/formatThreadTime'
import { STATUS_LABEL, STATUS_ROW_STYLE } from '../../lib/messageStatus'
import type { MessageThread } from '../../lib/types'

interface MessageRowProps {
  thread: MessageThread
  showStatusChip: boolean
  onOpen: (ticketId: number) => void
}

export const MessageRow = ({
  thread,
  showStatusChip,
  onOpen,
}: MessageRowProps) => {
  const { ticketId, subject, status, preview, updatedAt } = thread
  const statusStyle = STATUS_ROW_STYLE[status]
  const previewLine = preview
    ? `${preview.author === 'you' ? 'You' : 'Heard'}: ${preview.text}`
    : null

  return (
    <button
      type="button"
      onClick={() => onOpen(ticketId)}
      className={mtc(
        'flex w-full cursor-pointer flex-col gap-1 rounded-2xl border border-neutral-100 bg-neutral-0 px-4 py-3.5 text-left',
        'hover:bg-neutral-25 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        statusStyle.row
      )}
    >
      <Text variant={TypographyStyles.LABEL_SM} className="w-full truncate">
        {subject}
      </Text>

      {previewLine && (
        <Text
          variant={TypographyStyles.BODY_SM}
          className="w-full truncate text-neutral-600"
        >
          {previewLine}
        </Text>
      )}

      <div className="mt-0.5 flex w-full items-center gap-2">
        {showStatusChip && (
          <>
            <span className="flex items-center gap-1">
              {statusStyle.icon && (
                <Icon
                  icon={statusStyle.icon}
                  color="text-neutral-500"
                  size="xs"
                  backgroundClassName="size-auto"
                />
              )}
              <Text variant={statusStyle.variant} className={statusStyle.label}>
                {STATUS_LABEL[status]}
              </Text>
            </span>
            <Text
              variant={TypographyStyles.BODY_XS}
              className="text-neutral-500"
              aria-hidden
            >
              ·
            </Text>
          </>
        )}
        <Text variant={TypographyStyles.BODY_XS} className="text-neutral-500">
          {formatThreadTime(updatedAt)}
        </Text>
        <Text
          variant={TypographyStyles.BODY_XS}
          className="ml-auto shrink-0 text-neutral-500"
        >
          {`#${ticketId}`}
        </Text>
      </div>
    </button>
  )
}
